var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("news.p44")))])]),_c('div',[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }